import {type OnlineOfferEngagementBody} from '../api/types/onlineOfferTypes';

/**
 * navigator.sendBeacon cannot set the X-Workspace header, so the tenant travels
 * via the `x-workspace` query parameter (supported backend-wide).
 */
export const buildEngagementBeaconRequest = (args: {
  offerId: string;
  workspace: string;
  body: OnlineOfferEngagementBody;
}) => ({
  url: `${process.env.API_URL}/dms/v1/business-case/online-offer/${args.offerId}/engagement?x-workspace=${encodeURIComponent(args.workspace)}`,
  blob: new Blob([JSON.stringify(args.body)], {type: 'application/json'}),
});
